<template>
  <div class="insurance-project-management">
    <div class="main-content">
      <div class="filter-section">
        <div class="filter-form">
          <div class="filter-item">
            <a-select
              v-model:value="filterValues.projectName"
              placeholder="项目名称"
              :allowClear="true"
              style="width: 100%;"
            >
              <a-select-option
                v-for="item in (filterOptions.projectName || [])"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <a-select
              v-model:value="filterValues.customerName"
              placeholder="客户公司/项目名称"
              :allowClear="true"
              style="width: 100%;"
            >
              <a-select-option
                v-for="item in (filterOptions.customerName || [])"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <a-select
              v-model:value="filterValues.businessType"
              placeholder="业务类型"
              :allowClear="true"
              style="width: 100%;"
            >
              <a-select-option
                v-for="item in (filterOptions.businessType || [])"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
          <div class="filter-item">
            <a-select
              v-model:value="filterValues.cooperationStatus"
              placeholder="合作状态"
              :allowClear="true"
              style="width: 100%;"
            >
              <a-select-option
                v-for="item in (filterOptions.cooperationStatus || [])"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div class="filter-actions">
          <a-button type="primary" @click="handleQuery" style="border-radius: 4px;">查询</a-button>
          <a-button @click="handleReset" style="border-radius: 4px;">重置</a-button>
        </div>
      </div>

      <div class="table-section">
        <div class="table-header">
          <a-button type="primary" @click="handleAddProject" style="border-radius: 4px;">新增投保项目</a-button>
        </div>
        <InsuranceTable
          ref="tableRef"
          :tableData="tableData"
          :filterValues="filterValues"
          @handleEdit="handleEditProject"
          @handleView="handleViewProject"
          @handleDelete="handleDeleteProject"
          @handleChildChange="handleChildChange"
          @handleCooperationStatusChange="handleCooperationStatusChange"
          @handleHistoryPolicy="handleHistoryPolicy"
        />
      </div>
    </div>

    <Drawer :visible="drawerVisible" :title="drawerTitle" @update:visible="drawerVisible = $event">
      <div class="form-wrapper">
        <div class="form-title">保险项目信息</div>
        <div class="form-card">
          <template v-if="!isViewMode">
            <a-form
              :form="mainForm"
              :label-col="{ span: 24 }"
              :wrapper-col="{ span: 24 }"
            >
              <div class="form-grid">
                <a-form-item label="项目名称">
                  <a-input
                    v-decorator="['projectName', { rules: [{ required: true, message: '请输入项目名称' }] }]"
                    placeholder="请输入项目名称"
                    @input="e => formData.projectName = e.target.value"
                  />
                </a-form-item>

                <a-form-item label="所属行业">
                  <a-select
                    v-decorator="['industry', { rules: [{ required: true, message: '请选择所属行业' }] }]"
                    placeholder="请选择"
                    style="width: 100%;"
                    @change="val => formData.industry = val"
                  >
                    <a-select-option
                      v-for="item in (industryOptions || [])"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="业务类型">
                  <a-select
                    v-decorator="['businessType', { rules: [{ required: true, message: '请选择业务类型' }] }]"
                    placeholder="请选择"
                    style="width: 100%;"
                    @change="val => handleBusinessTypeChange(val)"
                  >
                    <a-select-option
                      v-for="item in (businessTypeOptions || [])"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="实际用工单位">
                  <a-select
                    v-decorator="['actualEmployer', { rules: [{ required: true, message: '请选择实际用工单位' }] }]"
                    placeholder="请选择"
                    style="width: 100%;"
                    @change="val => formData.actualEmployer = val"
                  >
                    <a-select-option value="平台">平台</a-select-option>
                    <a-select-option value="客户">客户</a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="项目地址">
                  <a-cascader
                    v-decorator="['projectAddress', { rules: [{ required: true, message: '请选择项目地址' }], getValueFromEvent: val => val }]"
                    :options="cascaderOptions || []"
                    :field-names="{ label: 'label', value: 'label', children: 'children' }"
                    placeholder="请选择"
                    style="width: 100%;"
                    @change="val => formData.projectAddress = val"
                  />
                </a-form-item>

                <a-form-item label="详细地址">
                  <a-input
                    v-decorator="['addressDetail', { rules: [{ required: true, message: '请输入详细地址' }] }]"
                    placeholder="请输入"
                    style="width: 100%;"
                    @input="e => formData.addressDetail = e.target.value"
                  />
                </a-form-item>

                <a-form-item label="客户名称">
                  <a-select
                    v-decorator="['customerName', { rules: [{ required: true, message: '请选择客户名称' }] }]"
                    placeholder="请先选择业务类型"
                    style="width: 100%;"
                    :disabled="!formData.businessType"
                    @change="val => handleCustomerNameChange(val)"
                  >
                    <a-select-option
                      v-for="item in (filteredCustomerOptions || [])"
                      :key="item.value"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="客服专员">
                  <a-input
                    :value="formData.customerManager"
                    placeholder="根据客户名称自动绑定"
                    style="width: 100%;"
                    disabled
                  />
                </a-form-item>

                <a-form-item label="核算部门">
                  <a-cascader
                    v-decorator="['department', { rules: [{ required: true, message: '请选择核算部门' }], getValueFromEvent: val => val }]"
                    :options="departmentCascaderOptions || []"
                    :field-names="{ label: 'label', value: 'label', children: 'children' }"
                    placeholder="请选择核算部门"
                    style="width: 100%;"
                    @change="val => formData.department = val"
                  />
                </a-form-item>

                <a-form-item label="合作状态">
                  <a-select
                    v-decorator="['cooperationStatus', { rules: [{ required: true, message: '请选择合作状态' }] }]"
                    placeholder="请选择"
                    style="width: 100%;"
                    @change="val => formData.cooperationStatus = val"
                  >
                    <a-select-option
                      v-for="item in (cooperationStatusOptions || [])"
                      :key="item"
                      :value="item"
                    >
                      {{ item }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

                <a-form-item label="备注" class="full-width">
                  <a-textarea
                    v-decorator="['remark']"
                    placeholder="请输入备注"
                    :rows="4"
                    :max-length="500"
                    :showCount="true"
                    @input="e => formData.remark = e.target.value"
                  />
                </a-form-item>
              </div>
            </a-form>
          </template>

          <template v-else>
            <div class="form-grid">
              <div class="detail-item">
                <span class="detail-label">项目名称</span>
                <span class="detail-value">{{ formData.projectName || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">所属行业</span>
                <span class="detail-value">{{ formData.industry || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">业务类型</span>
                <span class="detail-value">{{ formData.businessType || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">实际用工单位</span>
                <span class="detail-value">{{ formData.actualEmployer || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">项目地址</span>
                <span class="detail-value">{{ formatCascaderValue(formData.projectAddress) || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">详细地址</span>
                <span class="detail-value">{{ formData.addressDetail || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">客户名称</span>
                <span class="detail-value">{{ formData.customerName || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">客服专员</span>
                <span class="detail-value">{{ formData.customerManager || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">核算部门</span>
                <span class="detail-value">{{ formatCascaderValue(formData.department) || '-' }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">合作状态</span>
                <span class="detail-value">{{ formData.cooperationStatus || '-' }}</span>
              </div>
              <div class="detail-item full-width">
                <span class="detail-label">备注</span>
                <span class="detail-value">{{ formData.remark || '-' }}</span>
              </div>
            </div>
          </template>
        </div>

        <div
          v-for="(product, index) in (insuranceProducts || [])"
          :key="product.id"
          class="insurance-product-wrapper"
          style="margin-top: 24px;"
        >
          <div class="product-header">
            <span class="product-title">{{ product.name }}</span>
            <span class="product-divider"></span>
            <span
              v-if="!isViewMode && insuranceProducts && insuranceProducts.length > 1"
              @click="handleDeleteInsuranceProduct(index)"
              class="delete-text"
            >
              删除
            </span>
          </div>

          <div class="form-card">
            <template v-if="!isViewMode">
              <a-form
                :form="productForms[index]"
                :label-col="{ span: 24 }"
                :wrapper-col="{ span: 24 }"
                class="insurance-form"
              >
                <div class="form-grid">
                  <a-form-item label="平台投保">
                    <a-select
                      v-decorator="['platformInsurance', { rules: [{ required: true, message: '请选择平台投保' }] }]"
                      placeholder="请选择"
                      style="width: 100%;"
                      @change="val => product.data.platformInsurance = val"
                    >
                      <a-select-option value="是">是</a-select-option>
                      <a-select-option value="否">否</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="保险套餐">
                    <a-select
                      v-decorator="['insurancePackage', { rules: [{ required: true, message: '请选择保险套餐' }] }]"
                      placeholder="请选择"
                      style="width: 100%;"
                      @change="val => { product.data.insurancePackage = val; handleInsurancePackageChange(product) }"
                    >
                      <a-select-option
                        v-for="item in (insurancePackageOptions || [])"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="套餐产品名称">
                    <a-input
                      v-decorator="['productName', { rules: [{ required: true, message: '请输入套餐产品名称' }] }]"
                      placeholder="请输入套餐产品名称"
                      style="width: 100%;"
                      @input="e => product.data.productName = e.target.value"
                    />
                  </a-form-item>

                  <a-form-item label="核算主体">
                    <a-select
                      v-decorator="['accountingSubject', { rules: [{ required: true, message: '请选择核算主体' }] }]"
                      placeholder="请选择"
                      style="width: 100%;"
                      @change="val => product.data.accountingSubject = val"
                    >
                      <a-select-option
                        v-for="item in (accountingSubjectOptions || [])"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="用工类型">
                    <a-select
                      v-decorator="['employmentType', { rules: [{ required: true, message: '请选择用工类型' }] }]"
                      placeholder="请选择"
                      style="width: 100%;"
                      mode="multiple"
                      @change="val => product.data.employmentType = val"
                    >
                      <a-select-option value="正式员工">正式员工</a-select-option>
                      <a-select-option value="实习生">实习生</a-select-option>
                      <a-select-option value="劳务派遣">劳务派遣</a-select-option>
                      <a-select-option value="临时工">临时工</a-select-option>
                      <a-select-option value="众包">众包</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="适用岗位">
                    <a-select
                      v-decorator="['position', { rules: [{ required: true, message: '请选择适用岗位' }] }]"
                      placeholder="请选择"
                      style="width: 100%;"
                      mode="multiple"
                      @change="val => product.data.position = val"
                    >
                      <a-select-option
                        v-for="item in (positionOptions || [])"
                        :key="item"
                        :value="item"
                      >
                        {{ item }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="项目类型">
                    <a-select
                      v-decorator="['projectType', { rules: [{ required: true, message: '请选择项目类型' }] }]"
                      placeholder="请选择"
                      style="width: 100%;"
                      @change="val => product.data.projectType = val"
                    >
                      <a-select-option value="成本项目">成本项目</a-select-option>
                      <a-select-option value="销售项目">销售项目</a-select-option>
                      <a-select-option value="科技研发">科技研发</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="最大投保人数">
                    <a-input-number
                      v-decorator="['maxInsuranceCount', { rules: [{ required: true, message: '请输入最大投保人数' }] }]"
                      placeholder="请输入最大投保人数"
                      style="width: 100%;"
                      @change="val => product.data.maxInsuranceCount = val"
                    />
                  </a-form-item>

                  <a-form-item label="销售账单周期">
                    <a-select
                      v-decorator="['billingCycle', { rules: [{ required: true, message: '请选择销售账单周期' }] }]"
                      placeholder="请选择"
                      style="width: 100%;"
                      @change="val => product.data.billingCycle = val"
                    >
                      <a-select-option value="月度">月度</a-select-option>
                      <a-select-option value="季度">季度</a-select-option>
                      <a-select-option value="自然月">自然月</a-select-option>
                      <a-select-option value="保单周期">保单周期</a-select-option>
                      <a-select-option value="不出">不出</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item label="客户工作地点" class="full-width">
                    <div
                      v-for="(locationItem, locationIndex) in (product.data.workLocationList || [{ workLocation: undefined, customerService: undefined }])"
                      :key="locationIndex"
                      class="work-location-item"
                    >
                      <a-select
                        v-model="locationItem.workLocation"
                        placeholder="请选择工作地点"
                        style="width: 45%;"
                        @change="val => handleWorkLocationChange(product, locationIndex, val)"
                      >
                        <a-select-option
                          v-for="item in (workLocationOptions || [])"
                          :key="item"
                          :value="item"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        v-model="locationItem.customerService"
                        placeholder="请选择客服专员"
                        style="width: 45%;"
                      >
                        <a-select-option
                          v-for="item in getCustomerServiceOptions(product, locationIndex)"
                          :key="item"
                          :value="item"
                        >
                          {{ item }}
                        </a-select-option>
                      </a-select>
                      <span
                        @click="handleRemoveWorkLocation(product, locationIndex)"
                        v-if="(product.data.workLocationList || []).length > 1"
                        class="location-icon-btn remove-location-icon"
                      >
                        <span style="line-height: 1;">－</span>
                      </span>
                      <span
                        @click="handleAddWorkLocation(product)"
                        v-if="locationIndex === (product.data.workLocationList || [{ workLocation: undefined, customerService: undefined }]).length - 1"
                        class="location-icon-btn add-location-icon"
                      >
                        <span style="line-height: 1;">+</span>
                      </span>
                    </div>
                  </a-form-item>

                  <a-form-item label="备注" class="full-width">
                    <a-textarea
                      v-model="product.data.insuranceRemark"
                      placeholder="请输入备注"
                      :rows="4"
                      :max-length="500"
                      :showCount="true"
                      style="width: 100%;"
                    />
                  </a-form-item>

                  <a-form-item label="是否启用">
                    <a-switch
                      v-model="product.data.isEnabled"
                      checked-children="启用"
                      un-checked-children="停用"
                    />
                  </a-form-item>
                </div>

                <div v-if="product.data.insurancePackage" class="package-info-section">
                  <div class="section-divider">
                    <a-divider />
                  </div>

                  <div class="detail-title">关联套餐信息</div>

                  <a-form-item label="保单号" class="full-width">
                    <a-select
                      v-decorator="['policyNumber', { rules: [{ required: true, message: '请选择保单号' }] }]"
                      placeholder="请选择保单号"
                      style="width: 100%;"
                      @change="val => { product.data.policyNumber = val; handlePolicyChange(product) }"
                      :allowClear="true"
                    >
                      <a-select-option
                        v-for="policy in getPoliciesForPackage(product.data.insurancePackage)"
                        :key="policy"
                        :value="policy"
                      >
                        {{ policy }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>

                  <div v-if="product.data.policyNumber" class="package-info-grid">
                    <div class="detail-item">
                      <span class="detail-label">险种类型</span>
                      <span class="detail-value">团体意外险</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">保险方案</span>
                      <span class="detail-value">方案一</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">辅助方案</span>
                      <span class="detail-value">无</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">投保人</span>
                      <span class="detail-value">{{ product.data.policyHolder || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">被保人</span>
                      <span class="detail-value">{{ formatArrayValue(product.data.insured) || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">保险公司</span>
                      <span class="detail-value">{{ product.data.insuranceCompany || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">险种名称</span>
                      <span class="detail-value">团体意外伤害保险</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">投保方式</span>
                      <span class="detail-value">在线投保</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">保险生效日期</span>
                      <span class="detail-value">{{ product.data.effectiveDate || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">成本价</span>
                      <span class="detail-value">¥50/人/月</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">指导价</span>
                      <span class="detail-value">¥60/人/月</span>
                    </div>
                  </div>

                  <a-form-item v-if="product.data.policyNumber" label="销售价" class="full-width sales-price-item">
                    <a-input
                      v-decorator="['salesPrice', { rules: [{ required: true, message: '请输入销售价' }] }]"
                      placeholder="0"
                      suffix="元/人/月"
                      style="width: 100%;"
                      @input="e => product.data.salesPrice = e.target.value"
                    />
                  </a-form-item>
                </div>
              </a-form>

              <div v-if="product.data.policyNumber" class="insurance-table">
                <vxe-table
                  :data="insuranceDetailTableData"
                  :column-config="{ resizable: true }"
                  :row-config="{ isHover: true, height: 40 }"
                  :header-config="{ height: 40 }"
                  border
                  show-overflow="title"
                  size="small"
                >
                  <vxe-column field="insuranceDuty" title="保险责任" min-width="150" />
                  <vxe-column field="coverageAmount" title="保额(万)" width="120" align="right" />
                  <vxe-column field="premium" title="保费(元)" width="120" align="right" />
                  <vxe-column field="coverageDesc" title="保障说明" min-width="200" />
                </vxe-table>
              </div>
            </template>

            <template v-else>
              <div class="form-grid">
                <div class="detail-item">
                  <span class="detail-label">平台投保</span>
                  <span class="detail-value">{{ product.data.platformInsurance || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">保险套餐</span>
                  <span class="detail-value">{{ product.data.insurancePackage || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">套餐产品名称</span>
                  <span class="detail-value">{{ product.data.productName || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">核算主体</span>
                  <span class="detail-value">{{ product.data.accountingSubject || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">用工类型</span>
                  <span class="detail-value">{{ formatArrayValue(product.data.employmentType) || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">适用岗位</span>
                  <span class="detail-value">{{ formatArrayValue(product.data.position) || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">项目类型</span>
                  <span class="detail-value">{{ product.data.projectType || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">最大投保人数</span>
                  <span class="detail-value">{{ product.data.maxInsuranceCount || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">销售账单周期</span>
                  <span class="detail-value">{{ product.data.billingCycle || '-' }}</span>
                </div>
                <div class="detail-item full-width">
                  <span class="detail-label">客户工作地点</span>
                  <span class="detail-value">
                    <template v-if="product.data.workLocationList && product.data.workLocationList.length > 0">
                      <span v-for="(item, idx) in product.data.workLocationList" :key="idx" class="work-location-tag">
                        {{ item.workLocation || '-' }}（客服：{{ item.customerService || '-' }}）
                      </span>
                    </template>
                    <template v-else>-</template>
                  </span>
                </div>
                <div class="detail-item full-width">
                  <span class="detail-label">备注</span>
                  <span class="detail-value">{{ product.data.insuranceRemark || '-' }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">是否启用</span>
                  <span class="detail-value">{{ product.data.isEnabled ? '启用' : '停用' }}</span>
                </div>
              </div>

              <div v-if="product.data.insurancePackage">
                <div class="section-divider">
                  <a-divider />
                </div>

                <div class="detail-wrapper">
                  <div class="detail-title">关联套餐信息</div>
                  <div class="package-info-grid">
                    <div class="detail-item full-width">
                      <span class="detail-label">保单号</span>
                      <span class="detail-value">{{ product.data.policyNumber || '-' }}</span>
                    </div>

                    <template v-if="product.data.policyNumber">
                      <div class="detail-item">
                        <span class="detail-label">险种类型</span>
                        <span class="detail-value">团体意外险</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">保险方案</span>
                        <span class="detail-value">方案一</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">辅助方案</span>
                        <span class="detail-value">无</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">投保人</span>
                        <span class="detail-value">{{ product.data.policyHolder || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">被保人</span>
                        <span class="detail-value">{{ formatArrayValue(product.data.insured) || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">保险公司</span>
                        <span class="detail-value">{{ product.data.insuranceCompany || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">险种名称</span>
                        <span class="detail-value">团体意外伤害保险</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">投保方式</span>
                        <span class="detail-value">在线投保</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">保险生效日期</span>
                        <span class="detail-value">{{ product.data.effectiveDate || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">成本价</span>
                        <span class="detail-value">¥50/人/月</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">指导价</span>
                        <span class="detail-value">¥60/人/月</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">销售价</span>
                        <span class="detail-value">{{ product.data.salesPrice || '-' }}</span>
                      </div>
                    </template>
                  </div>
                </div>

                <div v-if="product.data.policyNumber" class="insurance-table">
                  <vxe-table
                    :data="insuranceDetailTableData"
                    :column-config="{ resizable: true }"
                    :row-config="{ isHover: true, height: 40 }"
                    :header-config="{ height: 40 }"
                    border
                    show-overflow="title"
                    size="small"
                  >
                    <vxe-column field="insuranceDuty" title="保险责任" min-width="150" />
                    <vxe-column field="coverageAmount" title="保额(万)" width="120" align="right" />
                    <vxe-column field="premium" title="保费(元)" width="120" align="right" />
                    <vxe-column field="coverageDesc" title="保障说明" min-width="200" />
                  </vxe-table>
                </div>
              </div>
            </template>
          </div>
        </div>

        <div v-if="!isViewMode" class="add-product-wrapper">
          <a-button
            type="default"
            @click="handleAddInsuranceProduct"
            class="add-product-button"
          >
            + 添加投保产品
          </a-button>
        </div>
      </div>
      <template #footer v-if="!isViewMode">
        <a-button @click="handleCancel">取消</a-button>
        <a-button
          v-if="!isEditMode"
          type="primary"
          :loading="isSubmitting"
          :disabled="isSubmitting"
          @click="handleSubmit"
        >
          {{ isSubmitting ? '正在新增中...' : '确定' }}
        </a-button>
        <a-button
          v-else
          type="primary"
          :loading="isSubmitting"
          :disabled="isSubmitting"
          @click="handleSave"
        >
          {{ isSubmitting ? '正在保存中...' : '保存' }}
        </a-button>
      </template>
    </Drawer>

    <HistoryPolicyDrawer
      :visible="historyPolicyVisible"
      :policies="historyPolicyData"
      @close="handleHistoryPolicyClose"
    />
  </div>
</template>

<script>
import VXETable from 'vxe-table'
import InsuranceTable from '../components/InsuranceTable.vue'
import Drawer from '../components/Drawer.vue'
import HistoryPolicyDrawer from '../components/HistoryPolicyDrawer.vue'
import insuranceDataSource from '../data/source.js'

export default {
  name: 'InsuranceProjectManagement',
  components: {
    InsuranceTable,
    Drawer,
    HistoryPolicyDrawer
  },
  mounted() {
    this.loadDataFromSource()
    this.logComponentStyles()
  },
  data() {
    return {
      tableRef: null,
      drawerVisible: false,
      isSubmitting: false,
      isEditMode: false,
      isViewMode: false,
      editRowData: null,
      historyPolicyVisible: false,
      historyPolicyData: [],
      historyPolicyProjectName: '',
      mainForm: null,
      productForms: [],
      customerData: {
        '装卸外包': [
          { label: '北京京东世纪贸易有限公司', value: '北京京东世纪贸易有限公司' },
          { label: '顺丰速运有限公司', value: '顺丰速运有限公司' },
          { label: '德邦物流股份有限公司', value: '德邦物流股份有限公司' }
        ],
        '灵活用工': [
          { label: '上海三快科技有限公司', value: '上海三快科技有限公司' },
          { label: '拉扎斯网络科技(上海)有限公司', value: '拉扎斯网络科技(上海)有限公司' },
          { label: '美团科技有限公司', value: '美团科技有限公司' }
        ],
        'BPO': [
          { label: '万宝盛华企业管理有限公司', value: '万宝盛华企业管理有限公司' },
          { label: '北京外企人力资源服务有限公司', value: '北京外企人力资源服务有限公司' },
          { label: '上海博尔捷人才服务有限公司', value: '上海博尔捷人才服务有限公司' }
        ],
        '人力资源': [
          { label: '中智经济技术合作股份有限公司', value: '中智经济技术合作股份有限公司' },
          { label: '北京汇智英才信息科技有限公司', value: '北京汇智英才信息科技有限公司' },
          { label: '广州红海人力资源集团股份有限公司', value: '广州红海人力资源集团股份有限公司' }
        ],
        '劳务派遣': [
          { label: '北京汇智英才信息科技有限公司', value: '北京汇智英才信息科技有限公司' },
          { label: '上海力德人才服务有限公司', value: '上海力德人才服务有限公司' },
          { label: '深圳鹏程人力资源有限公司', value: '深圳鹏程人力资源有限公司' }
        ],
        '业务外包': [
          { label: '软通动力信息技术有限公司', value: '软通动力信息技术有限公司' },
          { label: '中软国际有限公司', value: '中软国际有限公司' },
          { label: '东软集团股份有限公司', value: '东软集团股份有限公司' }
        ]
      },
      customerManagerMap: {},
      businessTypeOptions: ['装卸外包', '灵活用工', 'BPO', '人力资源', '劳务派遣', '业务外包'],
      tableData: [],
      filterValues: {
        projectName: undefined,
        customerName: undefined,
        businessType: undefined,
        cooperationStatus: undefined
      },
      insuranceDetailTableData: [
        { insuranceDuty: '意外伤害', coverageAmount: '10', premium: '50', coverageDesc: '意外身故、伤残' },
        { insuranceDuty: '意外医疗', coverageAmount: '2', premium: '30', coverageDesc: '意外伤害医疗费用' },
        { insuranceDuty: '意外住院津贴', coverageAmount: '0.05', premium: '20', coverageDesc: '因意外住院每天补贴' }
      ],
      formData: {
        projectName: undefined,
        industry: undefined,
        businessType: undefined,
        actualEmployer: undefined,
        projectAddress: [],
        addressDetail: '',
        customerName: undefined,
        department: [],
        customerManager: '',
        cooperationStatus: undefined,
        remark: ''
      },
      insuranceProducts: [
        {
          id: 1,
          name: '投保产品-01',
          data: {
            policyNumber: undefined,
            insurancePackage: undefined,
            policyHolder: undefined,
            insured: [],
            accountingSubject: undefined,
            employmentType: [],
            position: [],
            productName: '',
            workLocationList: [{ workLocation: undefined, customerService: undefined }],
            projectType: undefined,
            billingCycle: undefined,
            actualEmployer: undefined,
            isEnabled: true,
            maxInsuranceCount: undefined,
            projectAddress: [],
            addressDetail: '',
            platformInsurance: undefined,
            insuranceRemark: ''
          }
        }
      ],
      productIdCounter: 1,
      industryOptions: ['物流仓储', '外卖配送', '快递物流', '金融', '科技', '制造', '医疗', '零售', '教育', '房地产', '能源', '其他'],
      cooperationStatusOptions: ['合作中', '已终止'],
      departmentCascaderOptions: [
        {
          label: '华北运营中心',
          children: [
            { label: '财务部' },
            { label: '人力资源部' },
            { label: '业务部' },
            { label: '市场部' }
          ]
        },
        {
          label: '华东运营中心',
          children: [
            { label: '财务部' },
            { label: '人力资源部' },
            { label: '业务部' },
            { label: '技术部' }
          ]
        },
        {
          label: '华南运营中心',
          children: [
            { label: '财务部' },
            { label: '行政部' },
            { label: '业务部' },
            { label: '市场部' }
          ]
        },
        {
          label: '总部',
          children: [
            { label: '财务部' },
            { label: '人力资源部' },
            { label: '技术部' },
            { label: '行政部' }
          ]
        }
      ],
      insurancePackageOptions: ['套餐A', '套餐B', '套餐C', '套餐D'],
      policyNumberOptions: {
        '套餐A': ['POL2024001001', 'POL2024001002', 'POL2024001003'],
        '套餐B': ['POL2024002001', 'POL2024002002', 'POL2024002003'],
        '套餐C': ['POL2024003001', 'POL2024003002', 'POL2024003003'],
        '套餐D': ['POL2024004001', 'POL2024004002', 'POL2024004003']
      },
      accountingSubjectOptions: ['北京总公司', '上海分公司', '华南分部', '华东分部'],
      positionOptions: ['仓库管理员', '外卖骑手', '分拣员', '众包骑手', '客服', '销售', '技术', '管理', '行政', '全体员工', '注册骑手', '快递员', '新员工'],
      workLocationOptions: [
        '北京', '上海', '广州', '深圳', '杭州', '南京', '武汉',
        '成都', '重庆', '西安', '天津', '苏州', '长沙', '郑州',
        '青岛', '大连', '沈阳', '厦门', '福州', '济南', '合肥',
        '昆明', '贵阳', '南宁', '佛山', '东莞'
      ],
      employerOptions: ['XX人力资源有限公司', 'YY灵活用工平台', 'ZZ劳务派遣公司', '已终止合作', 'AA劳务派遣公司', 'BB人力外包公司'],
      maxCountOptions: ['10人', '20人', '50人', '100人', '不限'],
      cascaderOptions: [
        {
          label: '北京市',
          children: [
            {
              label: '市辖区',
              children: [
                { label: '朝阳区' },
                { label: '海淀区' },
                { label: '东城区' },
                { label: '西城区' },
                { label: '丰台区' },
                { label: '石景山区' },
                { label: '大兴区' },
                { label: '亦庄镇' }
              ]
            },
            {
              label: '大兴区',
              children: [
                { label: '亦庄镇' }
              ]
            }
          ]
        },
        {
          label: '上海市',
          children: [
            {
              label: '市辖区',
              children: [
                { label: '浦东新区' },
                { label: '徐汇区' },
                { label: '静安区' },
                { label: '黄浦区' },
                { label: '长宁区' },
                { label: '虹口区' },
                { label: '陆家嘴街道' }
              ]
            }
          ]
        },
        {
          label: '广东省',
          children: [
            {
              label: '广州市',
              children: [
                { label: '天河区' },
                { label: '越秀区' },
                { label: '白云区' },
                { label: '海珠区' },
                { label: '番禺区' },
                { label: '花都区' }
              ]
            },
            {
              label: '深圳市',
              children: [
                { label: '南山区' },
                { label: '福田区' },
                { label: '罗湖区' },
                { label: '宝安区' },
                { label: '龙岗区' },
                { label: '龙华区' }
              ]
            },
            {
              label: '佛山市',
              children: [
                { label: '禅城区' },
                { label: '南海区' },
                { label: '顺德区' },
                { label: '高明区' },
                { label: '三水区' }
              ]
            },
            {
              label: '东莞市',
              children: [
                { label: '莞城区' },
                { label: '南城区' },
                { label: '东城区' },
                { label: '万江区' },
                { label: '石碣镇' }
              ]
            }
          ]
        },
        {
          label: '浙江省',
          children: [
            {
              label: '杭州市',
              children: [
                { label: '上城区' },
                { label: '下城区' },
                { label: '西湖区' },
                { label: '拱墅区' },
                { label: '江干区' },
                { label: '滨江区' },
                { label: '萧山区' },
                { label: '余杭区' }
              ]
            },
            {
              label: '宁波市',
              children: [
                { label: '海曙区' },
                { label: '江北区' },
                { label: '北仑区' },
                { label: '镇海区' },
                { label: '鄞州区' },
                { label: '奉化区' }
              ]
            },
            {
              label: '温州市',
              children: [
                { label: '鹿城区' },
                { label: '龙湾区' },
                { label: '瓯海区' },
                { label: '洞头区' },
                { label: '瑞安市' },
                { label: '乐清市' }
              ]
            }
          ]
        },
        {
          label: '江苏省',
          children: [
            {
              label: '南京市',
              children: [
                { label: '玄武区' },
                { label: '秦淮区' },
                { label: '建邺区' },
                { label: '鼓楼区' },
                { label: '栖霞区' },
                { label: '雨花台区' }
              ]
            },
            {
              label: '苏州市',
              children: [
                { label: '姑苏区' },
                { label: '虎丘区' },
                { label: '吴中区' },
                { label: '相城区' },
                { label: '工业园区' },
                { label: '高新区' }
              ]
            }
          ]
        },
        {
          label: '四川省',
          children: [
            {
              label: '成都市',
              children: [
                { label: '锦江区' },
                { label: '青羊区' },
                { label: '金牛区' },
                { label: '武侯区' },
                { label: '成华区' },
                { label: '龙泉驿区' }
              ]
            }
          ]
        },
        {
          label: '湖北省',
          children: [
            {
              label: '武汉市',
              children: [
                { label: '江岸区' },
                { label: '江汉区' },
                { label: '硚口区' },
                { label: '汉阳区' },
                { label: '武昌区' },
                { label: '洪山区' }
              ]
            }
          ]
        },
        {
          label: '山东省',
          children: [
            {
              label: '济南市',
              children: [
                { label: '历下区' },
                { label: '市中区' },
                { label: '槐荫区' },
                { label: '天桥区' },
                { label: '历城区' },
                { label: '长清区' }
              ]
            },
            {
              label: '青岛市',
              children: [
                { label: '市南区' },
                { label: '市北区' },
                { label: '黄岛区' },
                { label: '崂山区' },
                { label: '李沧区' },
                { label: '城阳区' }
              ]
            }
          ]
        },
        {
          label: '河南省',
          children: [
            {
              label: '郑州市',
              children: [
                { label: '中原区' },
                { label: '二七区' },
                { label: '管城回族区' },
                { label: '金水区' },
                { label: '上街区' },
                { label: '惠济区' }
              ]
            }
          ]
        },
        {
          label: '河北省',
          children: [
            {
              label: '石家庄市',
              children: [
                { label: '长安区' },
                { label: '桥西区' },
                { label: '新华区' },
                { label: '井陉矿区' },
                { label: '裕华区' },
                { label: '藁城区' }
              ]
            }
          ]
        },
        {
          label: '湖南省',
          children: [
            {
              label: '长沙市',
              children: [
                { label: '芙蓉区' },
                { label: '天心区' },
                { label: '岳麓区' },
                { label: '开福区' },
                { label: '雨花区' },
                { label: '望城区' }
              ]
            }
          ]
        },
        {
          label: '安徽省',
          children: [
            {
              label: '合肥市',
              children: [
                { label: '瑶海区' },
                { label: '庐阳区' },
                { label: '蜀山区' },
                { label: '包河区' },
                { label: '长丰县' },
                { label: '肥东县' }
              ]
            }
          ]
        },
        {
          label: '福建省',
          children: [
            {
              label: '福州市',
              children: [
                { label: '鼓楼区' },
                { label: '台江区' },
                { label: '仓山区' },
                { label: '马尾区' },
                { label: '晋安区' },
                { label: '长乐区' }
              ]
            },
            {
              label: '厦门市',
              children: [
                { label: '思明区' },
                { label: '海沧区' },
                { label: '湖里区' },
                { label: '集美区' },
                { label: '同安区' },
                { label: '翔安区' }
              ]
            }
          ]
        },
        {
          label: '江西省',
          children: [
            {
              label: '南昌市',
              children: [
                { label: '东湖区' },
                { label: '西湖区' },
                { label: '青云谱区' },
                { label: '湾里区' },
                { label: '青山湖区' },
                { label: '新建区' }
              ]
            }
          ]
        },
        {
          label: '山西省',
          children: [
            {
              label: '太原市',
              children: [
                { label: '小店区' },
                { label: '迎泽区' },
                { label: '杏花岭区' },
                { label: '尖草坪区' },
                { label: '万柏林区' },
                { label: '晋源区' }
              ]
            }
          ]
        },
        {
          label: '辽宁省',
          children: [
            {
              label: '沈阳市',
              children: [
                { label: '和平区' },
                { label: '沈河区' },
                { label: '大东区' },
                { label: '皇姑区' },
                { label: '铁西区' },
                { label: '苏家屯区' }
              ]
            },
            {
              label: '大连市',
              children: [
                { label: '中山区' },
                { label: '西岗区' },
                { label: '沙河口区' },
                { label: '甘井子区' },
                { label: '旅顺口区' },
                { label: '金州区' }
              ]
            }
          ]
        },
        {
          label: '吉林省',
          children: [
            {
              label: '长春市',
              children: [
                { label: '南关区' },
                { label: '宽城区' },
                { label: '朝阳区' },
                { label: '二道区' },
                { label: '绿园区' },
                { label: '双阳区' }
              ]
            }
          ]
        },
        {
          label: '黑龙江省',
          children: [
            {
              label: '哈尔滨市',
              children: [
                { label: '道里区' },
                { label: '南岗区' },
                { label: '道外区' },
                { label: '平房区' },
                { label: '松北区' },
                { label: '香坊区' }
              ]
            }
          ]
        },
        {
          label: '陕西省',
          children: [
            {
              label: '西安市',
              children: [
                { label: '新城区' },
                { label: '碑林区' },
                { label: '莲湖区' },
                { label: '灞桥区' },
                { label: '未央区' },
                { label: '雁塔区' }
              ]
            }
          ]
        },
        {
          label: '云南省',
          children: [
            {
              label: '昆明市',
              children: [
                { label: '五华区' },
                { label: '盘龙区' },
                { label: '官渡区' },
                { label: '西山区' },
                { label: '东川区' },
                { label: '呈贡区' }
              ]
            }
          ]
        },
        {
          label: '贵州省',
          children: [
            {
              label: '贵阳市',
              children: [
                { label: '南明区' },
                { label: '云岩区' },
                { label: '花溪区' },
                { label: '乌当区' },
                { label: '白云区' },
                { label: '观山湖区' }
              ]
            }
          ]
        },
        {
          label: '广西壮族自治区',
          children: [
            {
              label: '南宁市',
              children: [
                { label: '兴宁区' },
                { label: '青秀区' },
                { label: '江南区' },
                { label: '西乡塘区' },
                { label: '良庆区' },
                { label: '邕宁区' }
              ]
            }
          ]
        },
        {
          label: '内蒙古自治区',
          children: [
            {
              label: '呼和浩特市',
              children: [
                { label: '新城区' },
                { label: '回民区' },
                { label: '玉泉区' },
                { label: '赛罕区' },
                { label: '土默特左旗' },
                { label: '托克托县' }
              ]
            }
          ]
        },
        {
          label: '新疆维吾尔自治区',
          children: [
            {
              label: '乌鲁木齐市',
              children: [
                { label: '天山区' },
                { label: '沙依巴克区' },
                { label: '新市区' },
                { label: '水磨沟区' },
                { label: '头屯河区' },
                { label: '达坂城区' }
              ]
            }
          ]
        },
        {
          label: '甘肃省',
          children: [
            {
              label: '兰州市',
              children: [
                { label: '城关区' },
                { label: '七里河区' },
                { label: '西固区' },
                { label: '安宁区' },
                { label: '红古区' },
                { label: '永登县' }
              ]
            }
          ]
        },
        {
          label: '海南省',
          children: [
            {
              label: '海口市',
              children: [
                { label: '秀英区' },
                { label: '龙华区' },
                { label: '琼山区' },
                { label: '美兰区' }
              ]
            },
            {
              label: '三亚市',
              children: [
                { label: '海棠区' },
                { label: '吉阳区' },
                { label: '天涯区' },
                { label: '崖州区' }
              ]
            }
          ]
        },
        {
          label: '宁夏回族自治区',
          children: [
            {
              label: '银川市',
              children: [
                { label: '兴庆区' },
                { label: '西夏区' },
                { label: '金凤区' },
                { label: '永宁县' },
                { label: '贺兰县' },
                { label: '灵武市' }
              ]
            }
          ]
        },
        {
          label: '青海省',
          children: [
            {
              label: '西宁市',
              children: [
                { label: '城东区' },
                { label: '城中区' },
                { label: '城西区' },
                { label: '城北区' },
                { label: '大通回族土族自治县' },
                { label: '湟中县' }
              ]
            }
          ]
        },
        {
          label: '西藏自治区',
          children: [
            {
              label: '拉萨市',
              children: [
                { label: '城关区' },
                { label: '堆龙德庆区' },
                { label: '达孜区' },
                { label: '林周县' },
                { label: '当雄县' },
                { label: '尼木县' }
              ]
            }
          ]
        },
        {
          label: '天津市',
          children: [
            {
              label: '市辖区',
              children: [
                { label: '和平区' },
                { label: '河东区' },
                { label: '河西区' },
                { label: '南开区' },
                { label: '河北区' },
                { label: '红桥区' }
              ]
            }
          ]
        },
        {
          label: '重庆市',
          children: [
            {
              label: '市辖区',
              children: [
                { label: '万州区' },
                { label: '渝中区' },
                { label: '江北区' },
                { label: '沙坪坝区' },
                { label: '九龙坡区' },
                { label: '南岸区' }
              ]
            }
          ]
        }
      ]
    }
  },
  computed: {
    drawerTitle() {
      if (this.isViewMode) return '投保项目详情'
      return this.isEditMode ? '编辑投保项目' : '新增投保项目'
    },
    filteredCustomerOptions() {
      if (!this.customerData) return []
      const businessType = this.formData.businessType
      if (!businessType) {
        return []
      }
      const options = this.customerData[businessType] || []
      // 确保返回的是有效的对象数组
      return options.filter(item => item && typeof item === 'object' && item.value)
    },
    allCustomerOptions() {
      const customers = []
      const customerValues = new Set()
      Object.values(this.customerData).forEach(items => {
        items.forEach(item => {
          if (item && typeof item === 'object' && item.value && !customerValues.has(item.value)) {
            customers.push(item)
            customerValues.add(item.value)
          }
        })
      })
      return customers
    },
    filterOptions() {
      const projectNameSet = new Set()
      const customerNameSet = new Set()
      const businessTypeSet = new Set()
      const cooperationStatusSet = new Set()
      
      // 添加静态业务类型选项
      if (this.businessTypeOptions && Array.isArray(this.businessTypeOptions)) {
        this.businessTypeOptions.forEach(bt => businessTypeSet.add(bt))
      }
      
      // 添加静态合作状态选项
      if (this.cooperationStatusOptions && Array.isArray(this.cooperationStatusOptions)) {
        this.cooperationStatusOptions.forEach(cs => cooperationStatusSet.add(cs))
      }
      
      if (this.tableData && Array.isArray(this.tableData)) {
        this.tableData.forEach(item => {
          if (item && item.projectName) projectNameSet.add(item.projectName)
          if (item && item.customerName) customerNameSet.add(item.customerName)
          if (item && item.businessType) businessTypeSet.add(item.businessType)
          if (item && item.cooperationStatus) cooperationStatusSet.add(item.cooperationStatus)
        })
      }
      
      return {
        projectName: Array.from(projectNameSet).map(value => ({ label: value, value: value })),
        customerName: Array.from(customerNameSet).map(value => ({ label: value, value: value })),
        businessType: Array.from(businessTypeSet).map(value => ({ label: value, value: value })),
        cooperationStatus: Array.from(cooperationStatusSet).map(value => ({ label: value, value: value }))
      }
    }
  },
  watch: {
    tableData: {
      handler() {
        this.initCustomerData()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    convertWorkLocationToList(child) {
      if (child.workLocationList && Array.isArray(child.workLocationList)) {
        return child.workLocationList
      }
      if (child.workLocation) {
        const locations = Array.isArray(child.workLocation) ? child.workLocation : child.workLocation.split('、')
        return locations.map(loc => ({ workLocation: loc, customerService: child.customerService || child.customerManager || undefined }))
      }
      return [{ workLocation: undefined, customerService: undefined }]
    },
    handleWorkLocationChange(product, locationIndex, val) {
      if (val) {
        const customerManager = this.customerManagerMap[this.formData.customerName]
        if (customerManager) {
          product.data.workLocationList[locationIndex].customerService = customerManager
        }
      }
    },
    handleAddWorkLocation(product) {
      product.data.workLocationList = [...product.data.workLocationList, { workLocation: undefined, customerService: undefined }]
    },
    handleRemoveWorkLocation(product, locationIndex) {
      if (product.data.workLocationList.length > 1) {
        product.data.workLocationList = product.data.workLocationList.filter((_, idx) => idx !== locationIndex)
      }
    },
    getCustomerServiceOptions(product, locationIndex) {
      return ['李晓华', '赵文静', '陈静', '吴小丽', '吴强', '黄丽', '李杰', '周丽']
    },
    handleHistoryPolicy(childRow) {
      console.log('历史保单按钮被点击，行数据:', childRow)
      
      let project = null
      let projectName = ''
      let allPolicies = []
      
      for (const p of this.tableData) {
        if (p.children && Array.isArray(p.children)) {
          const found = p.children.find(c => c.id === childRow.id || c.productName === childRow.productName)
          if (found) {
            project = p
            projectName = p.projectName || ''
            
            p.children.forEach(child => {
              if (child.policyNumber) {
                const policyData = this.getPolicyData(child.policyNumber)
                const effectiveStartDate = child.effectiveStartDate || policyData.effectiveStartDate || ''
                const effectiveEndDate = child.effectiveEndDate || policyData.effectiveEndDate || ''
                const isExpired = effectiveEndDate && new Date(effectiveEndDate) < new Date()
                
                allPolicies.push({
                  insuranceType: '团体意外险',
                  insuranceCompany: child.insuranceCompany || policyData.insuranceCompany || '',
                  insuranceName: '团体意外伤害保险',
                  policyNo: child.policyNumber,
                  effectiveStartDate: effectiveStartDate,
                  effectiveEndDate: effectiveEndDate,
                  effectiveDate: effectiveStartDate && effectiveEndDate ? `${effectiveStartDate} ~ ${effectiveEndDate}` : (effectiveStartDate || effectiveEndDate || ''),
                  costPrice: child.costPrice || '¥50/人/月',
                  isExpired: isExpired
                })
              }
            })
            break
          }
        }
      }

      console.log('找到的项目:', project)
      console.log('所有保单:', allPolicies)
      
      this.historyPolicyData = allPolicies.filter(p => p.isExpired)
      this.historyPolicyProjectName = projectName
      this.historyPolicyVisible = true
      console.log('历史保单抽屉是否打开:', this.historyPolicyVisible)
    },
    handleHistoryPolicyClose() {
      this.historyPolicyVisible = false
    },
    loadDataFromSource() {
      const projects = insuranceDataSource.getProjects()
      this.tableData = projects && projects.length > 0 ? [...projects] : []
    },
    saveDataToSource() {
      insuranceDataSource.insuranceProjects = [...this.tableData]
    },
    logComponentStyles() {
      console.log('=== 组件实际渲染样式值 ===')
      
      const primaryButton = document.querySelector('.primary-button')
      if (primaryButton) {
        const styles = getComputedStyle(primaryButton)
        console.log('主按钮样式:', {
          backgroundColor: styles.backgroundColor,
          color: styles.color,
          borderColor: styles.borderColor
        })
      }
      
      const secondaryButton = document.querySelector('.secondary-button')
      if (secondaryButton) {
        const styles = getComputedStyle(secondaryButton)
        console.log('次级按钮样式:', {
          backgroundColor: styles.backgroundColor,
          color: styles.color,
          borderColor: styles.borderColor
        })
      }
      
      const addButton = document.querySelector('.add-product-button')
      if (addButton) {
        const styles = getComputedStyle(addButton)
        console.log('添加产品按钮样式:', {
          backgroundColor: styles.backgroundColor,
          color: styles.color,
          borderColor: styles.borderColor
        })
      }
      
      const root = document.documentElement
      console.log('全局变量:', {
        primaryColor: getComputedStyle(root).getPropertyValue('--ant-primary-color'),
        primaryColorHover: getComputedStyle(root).getPropertyValue('--ant-primary-color-hover'),
        primaryColorActive: getComputedStyle(root).getPropertyValue('--ant-primary-color-active'),
        errorColor: getComputedStyle(root).getPropertyValue('--ant-error-color'),
        textColor: getComputedStyle(root).getPropertyValue('--ant-text-color'),
        textColorSecondary: getComputedStyle(root).getPropertyValue('--ant-text-color-secondary'),
        borderColorBase: getComputedStyle(root).getPropertyValue('--ant-border-color-base'),
        white: getComputedStyle(root).getPropertyValue('--ant-white')
      })
      
      console.log('=== 样式日志结束 ===')
    },
    initCustomerData() {
       const customerManagerMap = {}
       const customerDataFromTable = {}

       if (this.tableData && Array.isArray(this.tableData)) {
         this.tableData.forEach(item => {
           if (item && item.customerName && item.businessType) {
             if (!customerDataFromTable[item.businessType]) {
               customerDataFromTable[item.businessType] = []
             }
             if (!customerDataFromTable[item.businessType].some(c => c.value === item.customerName)) {
               customerDataFromTable[item.businessType].push({ label: item.customerName, value: item.customerName })
             }
             if (item.customerManager) {
               customerManagerMap[item.customerName] = item.customerManager
             }
           }
         })
       }

       // 如果表格中有新的客户数据，合并到现有的 customerData 中
       if (Object.keys(customerDataFromTable).length > 0) {
         Object.keys(customerDataFromTable).forEach(businessType => {
           if (this.customerData[businessType] && Array.isArray(this.customerData[businessType])) {
             // 合并新数据
             const existingMap = new Map(
               this.customerData[businessType].map(c => [c.value, c])
             )
             customerDataFromTable[businessType].forEach(customer => {
               if (!existingMap.has(customer.value)) {
                 existingMap.set(customer.value, customer)
               }
             })
             // 使用 $set 确保响应式更新
             this.$set(this.customerData, businessType, Array.from(existingMap.values()))
           } else {
             this.$set(this.customerData, businessType, customerDataFromTable[businessType])
           }
         })
       }

       this.customerManagerMap = customerManagerMap
     },
    async handleAddInsuranceProduct() {
      await this.$nextTick()
      
      try {
        if (this.mainForm) {
          await new Promise((resolve, reject) => {
            this.mainForm.validateFields((err) => {
              if (err) reject(err)
              else resolve()
            })
          })
        }
        for (const form of this.productForms) {
          if (form) {
            await new Promise((resolve, reject) => {
              form.validateFields((err) => {
                if (err) reject(err)
                else resolve()
              })
            })
          }
        }
      } catch (err) {
        return
      }

      this.productIdCounter++
      const newProduct = {
        id: this.productIdCounter,
        name: `投保产品-0${this.productIdCounter}`,
        data: {
          policyNumber: undefined,
          insurancePackage: undefined,
          policyHolder: undefined,
          insured: [],
          accountingSubject: undefined,
          employmentType: [],
          position: [],
          productName: '',
          workLocationList: [{ workLocation: undefined, customerService: undefined }],
          projectType: undefined,
          billingCycle: undefined,
          actualEmployer: undefined,
          isEnabled: true,
          maxInsuranceCount: undefined,
          projectAddress: [],
          addressDetail: '',
          platformInsurance: undefined,
          insuranceRemark: ''
        }
      }
      this.insuranceProducts.push(newProduct)
      const form = this.$form.createForm(this, { name: `product_form_edit_${this.productIdCounter}` })
      this.productForms.push(form)
    },
    handleDeleteInsuranceProduct(index) {
      if (this.insuranceProducts && this.insuranceProducts.length > 1) {
        this.$confirm({
          title: '提示',
          content: '确定要删除该投保产品吗？',
          okText: '确定',
          cancelText: '取消',
          onOk: () => {
            this.insuranceProducts.splice(index, 1)
            this.productForms.splice(index, 1)

            this.insuranceProducts.forEach((product, idx) => {
              product.name = `投保产品-0${idx + 1}`
            })
          }
        })
      }
    },
    handlePolicyChange(product) {
      if (product && product.data && product.data.policyNumber) {
        console.log('Policy changed:', product.data.policyNumber)
        const policyData = this.getPolicyData(product.data.policyNumber)
        product.data.effectiveDate = policyData.effectiveDate
        product.data.salesPrice = policyData.salesPrice
        product.data.insuranceCompany = policyData.insuranceCompany
        product.data.policyHolder = policyData.policyHolder
        product.data.insured = policyData.insured
      } else if (product && product.data) {
        product.data.effectiveDate = ''
        product.data.salesPrice = ''
        product.data.insuranceCompany = ''
        product.data.policyHolder = ''
        product.data.insured = []
      }
    },
    getPolicyData(policyNo) {
      const policyDataMap = {
        'POL2024001234': {
          effectiveDate: '2024-01-15',
          effectiveStartDate: '2024-01-15',
          effectiveEndDate: '2025-01-14',
          salesPrice: '80元/人/月',
          insuranceCompany: '平安保险',
          policyHolder: '北京京东世纪贸易有限公司',
          insured: ['全体员工'],
          costPrice: '¥50/人/月'
        },
        'POL2024005678': {
          effectiveDate: '2024-02-20',
          effectiveStartDate: '2024-02-20',
          effectiveEndDate: '2025-02-19',
          salesPrice: '75元/人/月',
          insuranceCompany: '太平洋保险',
          policyHolder: '上海三快科技有限公司',
          insured: ['注册骑手'],
          costPrice: '¥48/人/月'
        },
        'P001': {
          effectiveDate: '2024-03-10',
          effectiveStartDate: '2024-03-10',
          effectiveEndDate: '2025-03-09',
          salesPrice: '85元/人/月',
          insuranceCompany: '中国人寿',
          policyHolder: '万宝盛华企业管理有限公司',
          insured: ['员工'],
          costPrice: '¥52/人/月'
        },
        'P002': {
          effectiveDate: '2024-03-15',
          effectiveStartDate: '2024-03-15',
          effectiveEndDate: '2025-03-14',
          salesPrice: '78元/人/月',
          insuranceCompany: '新华保险',
          policyHolder: '中智经济技术合作股份有限公司',
          insured: ['员工', '员工及其家属'],
          costPrice: '¥50/人/月'
        },
        'P003': {
          effectiveDate: '2024-03-20',
          effectiveStartDate: '2024-03-20',
          effectiveEndDate: '2025-03-19',
          salesPrice: '82元/人/月',
          insuranceCompany: '泰康保险',
          policyHolder: '北京汇智英才信息科技有限公司',
          insured: ['员工'],
          costPrice: '¥51/人/月'
        },
        'P004': {
          effectiveDate: '2024-04-05',
          effectiveStartDate: '2024-04-05',
          effectiveEndDate: '2025-04-04',
          salesPrice: '72元/人/月',
          insuranceCompany: '人保财险',
          policyHolder: '软通动力信息技术有限公司',
          insured: ['全体员工'],
          costPrice: '¥45/人/月'
        },
        'P005': {
          effectiveDate: '2024-04-10',
          effectiveStartDate: '2024-04-10',
          effectiveEndDate: '2025-04-09',
          salesPrice: '70元/人/月',
          insuranceCompany: '大地保险',
          policyHolder: '顺丰速运有限公司',
          insured: ['分拣员、快递员'],
          costPrice: '¥44/人/月'
        },
        'P006': {
          effectiveDate: '2024-05-01',
          effectiveStartDate: '2024-05-01',
          effectiveEndDate: '2025-04-30',
          salesPrice: '88元/人/月',
          insuranceCompany: '阳光保险',
          policyHolder: '拉扎斯网络科技(上海)有限公司',
          insured: ['蜂鸟众包骑手'],
          costPrice: '¥55/人/月'
        },
        'P007': {
          effectiveDate: '2024-05-05',
          effectiveStartDate: '2024-05-05',
          effectiveEndDate: '2025-05-04',
          salesPrice: '90元/人/月',
          insuranceCompany: '中华保险',
          policyHolder: '德邦物流股份有限公司',
          insured: ['员工'],
          costPrice: '¥58/人/月'
        },
        'P008': {
          effectiveDate: '2024-05-10',
          effectiveStartDate: '2024-05-10',
          effectiveEndDate: '2025-05-09',
          salesPrice: '86元/人/月',
          insuranceCompany: '友邦保险',
          policyHolder: '北京外企人力资源服务有限公司',
          insured: ['员工'],
          costPrice: '¥54/人/月'
        },
        'P009': {
          effectiveDate: '2024-05-15',
          effectiveStartDate: '2024-05-15',
          effectiveEndDate: '2025-05-14',
          salesPrice: '84元/人/月',
          insuranceCompany: '招商信诺',
          policyHolder: '美团科技有限公司',
          insured: ['员工'],
          costPrice: '¥53/人/月'
        }
      }
      return policyDataMap[policyNo] || {
        effectiveDate: '',
        effectiveStartDate: '',
        effectiveEndDate: '',
        salesPrice: '',
        insuranceCompany: '',
        policyHolder: '',
        insured: [],
        costPrice: ''
      }
    },
    handleBusinessTypeChange(val) {
      this.formData.businessType = val
      this.formData.customerName = undefined
      this.formData.customerManager = ''
    },
    handleCustomerNameChange(val) {
      this.formData.customerName = val
      this.formData.customerManager = this.customerManagerMap[val] || ''
    },
    handleQuery() {
      this.$refs.tableRef.handleFilter()
    },
    handleReset() {
      this.filterValues = {
        projectName: undefined,
        customerName: undefined,
        businessType: undefined,
        cooperationStatus: undefined
      }
    },
    formatArrayValue(value) {
      if (!value) return ''
      if (Array.isArray(value)) return value.join('、')
      return value
    },
    formatCascaderValue(value) {
      if (!value) return ''
      if (Array.isArray(value)) return value.join('')
      return value
    },
    getPoliciesForPackage(packageName) {
      if (!packageName) return []
      const policyMap = {
        '套餐A': ['POL2024001234', 'P001', 'P002'],
        '套餐B': ['POL2024005678', 'P004', 'P005'],
        '套餐C': ['P006', 'P007', 'P008', 'P009']
      }
      const policies = policyMap[packageName] || []
      return policies.length > 0 ? policies : []
    },
    getPolicyPackage(policyNo) {
      if (!policyNo) return ''
      const reverseMap = {
        'POL2024001234': '套餐A',
        'POL2024005678': '套餐B',
        'P001': '套餐A',
        'P002': '套餐A',
        'P003': '套餐A',
        'P004': '套餐B',
        'P005': '套餐B',
        'P006': '套餐C',
        'P007': '套餐C',
        'P008': '套餐C',
        'P009': '套餐C'
      }
      return reverseMap[policyNo] || ''
    },
    handleInsurancePackageChange(product) {
      if (product && product.data) {
        product.data.policyNumber = ''
      }
    },
    handleAddProject() {
      this.resetForm()
      this.isEditMode = false
      this.isViewMode = false
      this.editRowData = null
      
      this.drawerVisible = true
      this.mainForm = this.$form.createForm(this, { name: 'insurance_form' })
      this.productForms = this.insuranceProducts.map((product) => {
        return this.$form.createForm(this, { name: `product_form_edit_${product.id}` })
      })
      this.$nextTick(() => {
        this.mainForm.setFieldsValue({
          projectName: this.formData.projectName,
          industry: this.formData.industry,
          businessType: this.formData.businessType,
          actualEmployer: this.formData.actualEmployer,
          projectAddress: this.formData.projectAddress,
          addressDetail: this.formData.addressDetail,
          customerName: this.formData.customerName,
          department: this.formData.department,
          cooperationStatus: this.formData.cooperationStatus,
          remark: this.formData.remark
        })
        this.productForms.forEach((form, index) => {
          if (form && this.insuranceProducts[index]) {
            const data = this.insuranceProducts[index].data
            form.setFieldsValue({
              platformInsurance: data.platformInsurance,
              insurancePackage: data.insurancePackage,
              productName: data.productName,
              accountingSubject: data.accountingSubject,
              employmentType: data.employmentType,
              position: data.position,
              projectType: data.projectType,
              maxInsuranceCount: data.maxInsuranceCount,
              billingCycle: data.billingCycle,
              policyNumber: data.policyNumber,
              salesPrice: data.salesPrice
            })
          }
        })
      })
    },
    handleViewProject(row) {
      this.resetForm()
      this.isViewMode = true
      this.isEditMode = false
      this.editRowData = row

      this.formData.projectName = row.projectName || ''
      this.formData.industry = row.industry || undefined
      this.formData.businessType = row.businessType || undefined
      this.formData.actualEmployer = row.actualEmployer || undefined
      this.formData.projectAddress = row.projectAddress || []
      this.formData.addressDetail = row.addressDetail || ''
      this.formData.customerName = row.customerName || undefined
      this.formData.department = row.department || []
      this.formData.customerManager = row.customerManager || ''
      this.formData.cooperationStatus = row.cooperationStatus || undefined
      this.formData.remark = row.remark || ''

      if (row.children && row.children.length > 0) {
        this.insuranceProducts = row.children.map((child, index) => {
          const firstPolicy = child.policies && child.policies.length > 0 ? child.policies[0] : {}
          return {
            id: index + 1,
            name: `投保产品-0${index + 1}`,
            data: {
              policyHolder: child.policyHolder || firstPolicy.policyHolder || undefined,
              insured: child.insured ? (Array.isArray(child.insured) ? child.insured : [child.insured]) : (firstPolicy.insured ? (Array.isArray(firstPolicy.insured) ? firstPolicy.insured : [firstPolicy.insured]) : []),
              policyNumber: child.policyNo || child.policyNumber || undefined,
              salesPrice: child.salesPrice || firstPolicy.salesPrice || undefined,
              effectiveDate: child.effectiveDate || firstPolicy.effectiveDate || undefined,
              insuranceCompany: child.insuranceCompany || firstPolicy.insuranceCompany || undefined,
              insurancePackage: child.insurancePackage || undefined,
              accountingSubject: child.accountingSubject || child.accountingEntity || undefined,
              employmentType: Array.isArray(child.employmentType) ? child.employmentType : (child.employmentType ? [child.employmentType] : []),
              position: Array.isArray(child.position) ? child.position : (child.position ? [child.position] : []),
              productName: child.productName || '',
              workLocationList: this.convertWorkLocationToList(child),
              projectType: child.projectType || undefined,
              billingCycle: child.billingCycle || undefined,
              actualEmployer: child.actualEmployer || undefined,
              isEnabled: child.enabled,
              maxInsuranceCount: child.maxInsuranceCount || undefined,
              projectAddress: child.projectAddress || [],
              addressDetail: child.addressDetail || '',
              platformInsurance: child.platformInsurance || undefined,
              insuranceRemark: child.insuranceRemark || ''
            }
          }
        })
      }

      this.drawerVisible = true
    },
    handleEditProject(row) {
      this.resetForm()
      this.isEditMode = true
      this.isViewMode = false

      const tableIndex = (this.tableData || []).findIndex(item => item && item.id === row.id)
      if (tableIndex !== -1) {
        this.editRowData = this.tableData[tableIndex]
      } else {
        this.editRowData = row
      }

      this.formData.projectName = this.editRowData.projectName || ''
      this.formData.industry = this.editRowData.industry || undefined
      this.formData.businessType = this.editRowData.businessType || undefined
      this.formData.actualEmployer = this.editRowData.actualEmployer || undefined
      this.formData.projectAddress = this.editRowData.projectAddress || []
      this.formData.addressDetail = this.editRowData.addressDetail || ''
      this.formData.customerName = this.editRowData.customerName || undefined
      this.formData.department = this.editRowData.department || []
      this.formData.customerManager = this.editRowData.customerManager || ''
      this.formData.cooperationStatus = this.editRowData.cooperationStatus || undefined
      this.formData.remark = this.editRowData.remark || ''

      if (this.editRowData && this.editRowData.children && this.editRowData.children.length > 0) {
        this.insuranceProducts = this.editRowData.children.map((child, index) => {
          const firstPolicy = child.policies && child.policies.length > 0 ? child.policies[0] : {}
          return {
            id: index + 1,
            name: `投保产品-0${index + 1}`,
            data: {
              policyHolder: child.policyHolder || firstPolicy.policyHolder || undefined,
              insured: child.insured ? (Array.isArray(child.insured) ? child.insured : [child.insured]) : (firstPolicy.insured ? (Array.isArray(firstPolicy.insured) ? firstPolicy.insured : [firstPolicy.insured]) : []),
              policyNumber: child.policyNo || child.policyNumber || undefined,
              salesPrice: child.salesPrice || firstPolicy.salesPrice || undefined,
              effectiveDate: child.effectiveDate || firstPolicy.effectiveDate || undefined,
              insuranceCompany: child.insuranceCompany || firstPolicy.insuranceCompany || undefined,
              insurancePackage: child.insurancePackage || undefined,
              accountingSubject: child.accountingSubject || child.accountingEntity || undefined,
              employmentType: Array.isArray(child.employmentType) ? child.employmentType : (child.employmentType ? [child.employmentType] : []),
              position: Array.isArray(child.position) ? child.position : (child.position ? [child.position] : []),
              productName: child.productName || '',
              workLocationList: this.convertWorkLocationToList(child),
              projectType: child.projectType || undefined,
              billingCycle: child.billingCycle || undefined,
              actualEmployer: child.actualEmployer || undefined,
              isEnabled: child.enabled,
              maxInsuranceCount: child.maxInsuranceCount || undefined,
              projectAddress: child.projectAddress || [],
              addressDetail: child.addressDetail || '',
              platformInsurance: child.platformInsurance || undefined,
              insuranceRemark: child.insuranceRemark || ''
            }
          }
        })
      } else {
        this.insuranceProducts = [{
          id: 1,
          name: '投保产品-01',
          data: {
            policyHolder: undefined,
            insured: [],
            insurancePackage: undefined,
            policyNumber: undefined,
            salesPrice: undefined,
            effectiveDate: undefined,
            insuranceCompany: undefined,
            accountingSubject: undefined,
            employmentType: [],
            position: [],
            productName: '',
            workLocationList: [{ workLocation: undefined, customerService: undefined }],
            projectType: undefined,
            billingCycle: undefined,
            actualEmployer: undefined,
            isEnabled: true,
            maxInsuranceCount: undefined,
            projectAddress: [],
            addressDetail: '',
            platformInsurance: undefined,
            insuranceRemark: ''
          }
        }]
      }

      this.drawerVisible = true
      this.mainForm = this.$form.createForm(this, { name: 'insurance_form' })
      this.productForms = this.insuranceProducts.map((product) => {
        return this.$form.createForm(this, { name: `product_form_edit_${product.id}` })
      })
      this.$nextTick(() => {
        this.mainForm.setFieldsValue({
          projectName: this.formData.projectName,
          industry: this.formData.industry,
          businessType: this.formData.businessType,
          actualEmployer: this.formData.actualEmployer,
          projectAddress: this.formData.projectAddress,
          addressDetail: this.formData.addressDetail,
          customerName: this.formData.customerName,
          department: this.formData.department,
          cooperationStatus: this.formData.cooperationStatus,
          remark: this.formData.remark
        })
        this.productForms.forEach((form, index) => {
          if (form && this.insuranceProducts[index]) {
            const data = this.insuranceProducts[index].data
            form.setFieldsValue({
              platformInsurance: data.platformInsurance,
              insurancePackage: data.insurancePackage,
              productName: data.productName,
              accountingSubject: data.accountingSubject,
              employmentType: data.employmentType,
              position: data.position,
              projectType: data.projectType,
              maxInsuranceCount: data.maxInsuranceCount,
              billingCycle: data.billingCycle,
              policyNumber: data.policyNumber,
              salesPrice: data.salesPrice
            })
          }
        })
      })
    },
    handleClose() {
      this.drawerVisible = false
      this.resetForm()
    },
    handleCancel() {
      this.drawerVisible = false
      this.resetForm()
    },
    handleSubmit() {
      this.doSubmit()
    },
    doSubmit() {
      this.mainForm.validateFields((mainErr, mainValues) => {
        if (mainErr) {
          return
        }

        const validatePromises = (this.productForms || []).map((form, index) => {
          return new Promise((resolve) => {
            if (form) {
              form.validateFields((err, values) => {
                resolve(!err)
              })
            } else {
              resolve(true)
            }
          })
        })

        Promise.all(validatePromises).then(results => {
          const allValid = results.every(valid => valid)
          if (!allValid) {
            return
          }

          this.isSubmitting = true

        const newId = Math.max(...(this.tableData || []).map(item => item.id), 0) + 1

        const children = (this.insuranceProducts || []).map((product, index) => {
          const childId = newId * 100 + index + 1
          const policyData = product.data.policyNumber ? this.getPolicyData(product.data.policyNumber) : {}
          const workLocationList = product.data.workLocationList || []
          return {
            id: childId,
            productName: product.data.productName || `产品${index + 1}`,
            policyNumber: product.data.policyNumber || '',
            salesPrice: product.data.salesPrice || '',
            insurancePackage: product.data.insurancePackage || '',
            accountingEntity: product.data.accountingSubject || '',
            workLocation: workLocationList.map(item => item.workLocation).filter(Boolean).join('、'),
            workLocationList: workLocationList,
            projectType: product.data.projectType || '',
            billingCycle: product.data.billingCycle || '',
            policyNo: product.data.policyNumber || `POL${new Date().getFullYear()}${String(childId).padStart(4, '0')}`,
            policyHolder: product.data.policyHolder || '',
            insured: Array.isArray(product.data.insured) ? product.data.insured.join('、') : product.data.insured || '员工',
            accountingSubject: product.data.accountingSubject || '',
            employmentType: product.data.employmentType || [],
            position: product.data.position || '',
            customerManager: this.formData.customerManager || '',
            enabled: product.data.isEnabled,
            actualEmployer: product.data.actualEmployer || '',
            maxInsuranceCount: product.data.maxInsuranceCount || 0,
            projectAddress: product.data.projectAddress || [],
            addressDetail: product.data.addressDetail || '',
            platformInsurance: product.data.platformInsurance || '',
            insuranceRemark: product.data.insuranceRemark || '',
            effectiveDate: product.data.effectiveDate || '',
            effectiveStartDate: product.data.effectiveStartDate || policyData.effectiveStartDate || '',
            effectiveEndDate: product.data.effectiveEndDate || policyData.effectiveEndDate || '',
            insuranceCompany: product.data.insuranceCompany || '',
            costPrice: product.data.costPrice || policyData.costPrice || '¥50/人/月'
          }
        })

        const now = new Date()
        const createTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`

        const newRow = {
          id: newId,
          createTime: createTime,
          projectName: this.formData.projectName || '',
          customerName: this.formData.customerName || '',
          businessType: this.formData.businessType || '',
          cooperationStatus: this.formData.cooperationStatus || '',
          industry: this.formData.industry || '',
          department: this.formData.department || [],
          customerManager: this.formData.customerManager || '',
          actualEmployer: this.formData.actualEmployer || '',
          projectAddress: this.formData.projectAddress || [],
          addressDetail: this.formData.addressDetail || '',
          remark: this.formData.remark || '',
          children: children
        }

        this.tableData.push(newRow)
        this.saveDataToSource()

        setTimeout(() => {
          this.isSubmitting = false
          this.$message.success('新增成功')
          this.drawerVisible = false
          this.resetForm()
        }, 1000)
        })
      })
    },
    handleSave() {
      this.doSave()
    },
    doSave() {
      this.mainForm.validateFields((mainErr) => {
        if (mainErr) {
          return
        }

        const validatePromises = (this.productForms || []).map(form => {
          return new Promise((resolve) => {
            if (form) {
              form.validateFields((err) => {
                resolve(!err)
              })
            } else {
              resolve(true)
            }
          })
        })

        Promise.all(validatePromises).then(results => {
          const allValid = results.every(valid => valid)
          if (!allValid) {
            return
          }

          this.isSubmitting = true

          const children = (this.insuranceProducts || []).map((product, idx) => {
            const parentId = this.editRowData ? this.editRowData.id : (Math.max(0, ...(this.tableData || []).map(item => item.id)) + 1)
            const existingChildId = this.editRowData?.children?.[idx]?.id
            const policyData = product.data.policyNumber ? this.getPolicyData(product.data.policyNumber) : {}
            const workLocationList = product.data.workLocationList || []
            return {
              id: existingChildId || (parentId * 1000 + idx + 1),
              productName: product.data.productName || `产品${idx + 1}`,
              policyNumber: product.data.policyNumber || '',
              salesPrice: product.data.salesPrice || '',
              insurancePackage: product.data.insurancePackage || '',
              accountingEntity: product.data.accountingSubject || '',
              workLocation: workLocationList.map(item => item.workLocation).filter(Boolean).join('、'),
              workLocationList: workLocationList,
              projectType: product.data.projectType || '',
              billingCycle: product.data.billingCycle || '',
              policyNo: product.data.policyNumber || '',
              policyHolder: product.data.policyHolder || '',
              insured: Array.isArray(product.data.insured) ? product.data.insured.join('、') : product.data.insured || '员工',
              accountingSubject: product.data.accountingSubject || '',
              employmentType: product.data.employmentType || [],
              position: product.data.position || '',
              customerManager: this.formData.customerManager || '',
              enabled: product.data.isEnabled,
              actualEmployer: product.data.actualEmployer || '',
              maxInsuranceCount: product.data.maxInsuranceCount || 0,
              projectAddress: product.data.projectAddress || [],
              addressDetail: product.data.addressDetail || '',
              platformInsurance: product.data.platformInsurance || '',
              insuranceRemark: product.data.insuranceRemark || '',
              effectiveDate: product.data.effectiveDate || '',
              effectiveStartDate: product.data.effectiveStartDate || policyData.effectiveStartDate || '',
              effectiveEndDate: product.data.effectiveEndDate || policyData.effectiveEndDate || '',
              insuranceCompany: product.data.insuranceCompany || '',
              costPrice: product.data.costPrice || policyData.costPrice || '¥50/人/月'
            }
          })

          if (this.isEditMode && this.editRowData) {
            const index = (this.tableData || []).findIndex(item => item.id === this.editRowData.id)
            if (index !== -1) {
              const row = this.tableData[index]
              row.projectName = this.formData.projectName || ''
              row.customerName = this.formData.customerName || ''
              row.businessType = this.formData.businessType || ''
              row.cooperationStatus = this.formData.cooperationStatus || ''
              row.industry = this.formData.industry || ''
              row.department = this.formData.department || []
              row.customerManager = this.formData.customerManager || ''
              row.actualEmployer = this.formData.actualEmployer || ''
              row.projectAddress = this.formData.projectAddress || []
              row.addressDetail = this.formData.addressDetail || ''
              row.remark = this.formData.remark || ''
              row.children = children
              this.$set(this.tableData, index, row)
            }
          } else {
            const maxId = Math.max(0, ...(this.tableData || []).map(item => item.id))
            const newRow = {
              id: maxId + 1,
              projectName: this.formData.projectName || '',
              customerName: this.formData.customerName || '',
              businessType: this.formData.businessType || '',
              cooperationStatus: this.formData.cooperationStatus || '',
              industry: this.formData.industry || '',
              department: this.formData.department || [],
              customerManager: this.formData.customerManager || '',
              actualEmployer: this.formData.actualEmployer || '',
              projectAddress: this.formData.projectAddress || [],
              addressDetail: this.formData.addressDetail || '',
              remark: this.formData.remark || '',
              children: children
            }
            this.tableData.push(newRow)
          }

          this.saveDataToSource()

          setTimeout(() => {
            this.isSubmitting = false
            this.$message.success('保存成功')
            this.drawerVisible = false
            this.resetForm()
          }, 1000)
        })
      })
    },
    handleChildChange(changedChild) {
      if (this.insuranceProducts && this.insuranceProducts.length > 0) {
        const index = this.insuranceProducts.findIndex(p => p.id === changedChild.id)
        if (index !== -1) {
          this.insuranceProducts[index].data.isEnabled = changedChild.enabled
        }
      }
    },
    handleCooperationStatusChange(row) {
      const index = (this.tableData || []).findIndex(item => item && item.id === row.id)
      if (index !== -1) {
        this.tableData[index].cooperationStatus = row.cooperationStatus
        this.saveDataToSource()
      }
    },
    handleDeleteProject(row) {
      const index = (this.tableData || []).findIndex(item => item && item.id === row.id)
      if (index !== -1) {
        this.tableData.splice(index, 1)
        this.saveDataToSource()
        this.$message.success('删除成功')
      }
    },
    resetForm() {
      this.isViewMode = false

      if (this.mainForm && typeof this.mainForm.resetFields === 'function') {
        this.mainForm.resetFields()
      }

      this.productForms = []

      this.insuranceProducts = [
        {
          id: 1,
          name: '投保产品-01',
          data: {
            policyNumber: undefined,
            insurancePackage: undefined,
            policyHolder: undefined,
            insured: [],
            accountingSubject: undefined,
            employmentType: [],
            position: [],
            productName: '',
            workLocationList: [{ workLocation: undefined, customerService: undefined }],
            projectType: undefined,
            billingCycle: undefined,
            actualEmployer: undefined,
            isEnabled: true,
            maxInsuranceCount: undefined,
            projectAddress: [],
            addressDetail: '',
            platformInsurance: undefined,
            insuranceRemark: ''
          }
        }
      ]

      this.formData = {
        projectName: '',
        industry: undefined,
        businessType: undefined,
        actualEmployer: undefined,
        projectAddress: [],
        addressDetail: '',
        customerName: undefined,
        department: [],
        customerManager: '',
        cooperationStatus: undefined,
        contactPerson: '',
        contactPhone: '',
        remark: ''
      }

      if (this.mainForm && typeof this.mainForm.resetFields === 'function') {
        try {
          this.mainForm.resetFields()
        } catch (e) {
          console.error('重置主表单失败:', e)
        }
      }
    }
  }
}
</script>

<style scoped>
.insurance-project-management {
  padding: 24px;
  background: #FFFFFF;
  overflow-x: auto;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-height: 0;
}

/* 强制覆盖选择器样式 - 最高优先级 */
:deep(.ant-select) .ant-select-selector {
  border-color: #D7D7DB !important;
  transition: all 0.3s ease !important;
}

:deep(.ant-select:not(.ant-select-disabled):hover) .ant-select-selector {
  border-color: #FC6732 !important !important;  /* ✅ 双重!important确保优先级 */
}

:deep(.ant-select-focused) .ant-select-selector,
:deep(.ant-select-selector:focus),
:deep(.ant-select-selector:active) {
  border-color: #FC6732 !important !important;  /* ✅ 双重!important确保优先级 */
  box-shadow: 0 0 0 2px rgba(252, 103, 50, 0.2) !important !important;  /* ✅ 双重!important确保优先级 */
}

:deep(.ant-select-open) .ant-select-selector {
  border-color: #FC6732 !important !important;  /* ✅ 双重!important确保优先级 */
}

:deep(.ant-select-dropdown-menu-item:hover) {
  background-color: #F7F8FA !important;
  color: #1B1C33 !important;
}

:deep(.ant-select-dropdown-menu-item-selected),
:deep(.ant-select-dropdown-menu-item-selected:hover) {
  background-color: #F7F8FA !important;
  color: #FC6732 !important !important;  /* ✅ 双重!important确保优先级 */
}

:deep(.ant-select-dropdown-menu-item-active),
:deep(.ant-select-dropdown-menu-item-active:hover) {
  background-color: #F7F8FA !important;
  color: #FC6732 !important !important;  /* ✅ 双重!important确保优先级 */
}

.main-content {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.filter-section {
  display: flex;
  align-items: center;
  column-gap: 16px;
  border: 1px solid #D7D7DB;
  border-radius: 8px;
  background: #F7F8FA;
  padding: 23px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  flex-shrink: 0;
}

.table-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-radius: 8px;
  overflow: visible;
  min-height: 0;
  margin-bottom: 24px;
}

.table-header {
  display: flex;
  justify-content: flex-end;
  background: #ffffff;
}

.primary-button {
  background-color: #FC6732;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 500;
  padding: 0 16px;
  height: 32px;
  min-height: 32px;
  line-height: 32px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  outline: none;
}

.primary-button:hover {
  background-color: #FC7647;
}

.primary-button:active {
  background-color: #E35D2D;
}

.primary-button:disabled,
.primary-button.is-loading {
  background-color: #FC6732;
  cursor: default;
}

.primary-button.is-loading {
  pointer-events: none;
}

.secondary-button {
  background-color: #FFFFFF;
  color: #FC6732;
  font-size: 14px;
  font-weight: 500;
  padding: 0 16px;
  height: 32px;
  min-height: 32px;
  line-height: 32px;
  border: 1px solid #FC6732;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  outline: none;
}

.secondary-button:hover {
  background-color: #FC6732;
  color: #FFFFFF;
}

.filter-form {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  flex: 1;
}

.filter-item {
  min-width: 0;
  display: block;
  width: 100%;
}

.filter-item :deep(.ant-select),
.filter-item :deep(.ant-input),
.filter-item :deep(.ant-cascader) {
  width: 100% !important;
  display: block !important;
}

.filter-actions {
  display: inline-flex;
  align-items: flex-start;
  column-gap: 16px;
  box-shadow: inset 1px 0px 0px 0px #D7D7DB;
  background: #F6F7F8;
  padding-left: 16px;
}

.form-wrapper {
  width: 100%;
}

.form-title {
  font-size: 16px;
  font-weight: 600;
  color: #1B1C33;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.insurance-product-wrapper {
  margin-bottom: 24px;
}

.product-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 8px;
  width: 100%;
}

.product-title {
  font-size: 16px;
  font-weight: 600;
  color: #1B1C33;
  white-space: nowrap;
}

.product-divider {
  width: 100%;
  height: 1px;
  background-color: #D7D7DB;
}

.delete-text {
  font-size: 14px;
  color: #FD5451;
  cursor: pointer;
  white-space: nowrap;
}

.delete-text:hover {
  color: #FF6B6B;
}

.add-product-wrapper {
  width: 100%;
  margin-bottom: 24px;
}

.add-product-button {
  width: 100%;
  height: 40px;
  border: 1px dashed #D7D7DB;
  color: #8D8E99;
  background-color: transparent;
  border-radius: 4px;
}

.add-product-button:hover {
  border-color: #FC6732;
  color: #FC6732;
}

.form-card {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
  box-sizing: border-box;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  width: 100%;
  box-sizing: border-box;
  align-items: start;
}

.form-grid-row {
  width: 100%;
  box-sizing: border-box;
  margin-top: 24px;
}

.form-grid-row:first-child {
  margin-top: 0;
}

.form-grid-row :deep(.project-address-form-item) {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
}

.form-grid :deep(.ant-form-item) {
  display: block;
  width: 100%;
  margin-bottom: 0;
  min-width: 0;
  max-width: 100%;
}

.form-grid :deep(.ant-select),
.form-grid :deep(.ant-input),
.form-grid :deep(.ant-input-affix-wrapper),
.form-grid :deep(.ant-cascader),
.form-grid :deep(.ant-input-number) {
  width: 100% !important;
  min-width: 0;
  display: block !important;
}

.form-grid :deep(.ant-form-item-control),
.form-grid :deep(.ant-form-item-control-wrapper) {
  display: block !important;
  width: 100%;
}

.project-address-form-item :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.project-address-form-item :deep(.project-address-row) {
  display: flex;
  gap: 8px;
  width: 100%;
}

.project-address-form-item :deep(.ant-cascader),
.project-address-form-item :deep(.ant-input) {
  flex: 1;
  width: auto !important;
}

.insurance-form {
  width: 100%;
  box-sizing: border-box;
}

.package-info-grid .inline-form-item {
  display: inline-block;
  vertical-align: top;
  margin-bottom: 0;
}

.package-info-grid .inline-form-item :deep(.ant-form-item-label) {
  display: inline-block;
}

.package-info-grid .inline-form-item :deep(.ant-form-item-control-wrapper) {
  display: inline-block;
}

.package-info-grid .inline-form-item :deep(.ant-form-item-control) {
  display: inline-block;
}

.insurance-form :deep(.ant-form-item) {
  width: 100%;
}

.full-width {
  grid-column: 1 / -1;
}

.half-width {
  grid-column: span 1;
}

.sales-price-item {
  margin-top: 16px;
}

:deep(.ant-form-item-label > label) {
  color: #1B1C33;
  font-weight: 400;
  font-size: 14px;
  padding: 0;
  line-height: normal;
}

:deep(.ant-form-item-explain-error) {
  color: #FD5451;
  font-size: 12px;
  padding-top: 4px;
}

:deep(.ant-input),
:deep(.ant-select-selector),
:deep(.ant-cascader-picker),
:deep(.ant-input-number),
:deep(.ant-input-number-input),
:deep(.ant-input-textarea textarea) {
  width: 100%;
}

:deep(input[type="number"]) {
  text-align: left;
}

:deep(input[type="number"])::-webkit-outer-spin-button,
:deep(input[type="number"])::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

:deep(input[type="number"]) {
  -moz-appearance: textfield;
}

:deep(.ant-input-show-count-suffix) {
  background: transparent;
  color: #8D8E99;
  font-size: 12px;
}

:deep(.ant-form-item) {
  margin-bottom: 0;
}

.section-divider {
  padding: 16px 0;
}

:deep(.ant-divider-horizontal) {
  border-top: 1px dashed #D7D7DB;
  margin: 0;
}

.detail-card {
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
}

.package-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-top: 16px;
}

.detail-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.detail-wrapper {
  width: 100%;
}

.detail-title {
  font-size: 14px;
  font-weight: 600;
  color: #1B1C33;
  margin-bottom: 16px;
}

.detail-inline-group {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-label {
  font-size: 14px;
  color: #8D8E99;
}

.required-star {
  color: #F56C6C;
  margin-right: 2px;
}

.detail-value {
  font-size: 14px;
  color: #1B1C33;
}

.insurance-table {
  width: 100%;
  box-sizing: border-box;
  margin-top: 16px;
}

.insurance-table :deep(.vxe-table) {
  border-radius: 4px;
  width: 100%;
}

.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-20px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.fade-slide-leave-active {
  position: absolute;
}

.work-location-item {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
  flex-shrink: 0;
}

.work-location-item .ant-select {
  flex: 1;
  min-width: 150px;
}

.project-address-row {
  display: flex;
  gap: 10px;
}

.project-address-row > * {
  flex: 1;
}

.work-location-item:last-child {
  margin-bottom: 0;
}

.location-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  flex-shrink: 0;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  transition: all 0.3s;
  user-select: none;
  background: #fff;
}

.location-icon-btn span {
  color: #1B1C33;
  transition: color 0.3s;
}

.location-icon-btn:hover {
  border-color: #FC6732;
}

.location-icon-btn:hover span {
  color: #FC6732;
}

.location-icon-btn:active {
  border-color: #FC6732;
}

.location-icon-btn:active span {
  color: #FC6732;
}

.work-location-tag {
  display: inline-block;
  padding: 2px 8px;
  margin-right: 8px;
  margin-bottom: 4px;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 12px;
}
</style>